<template>
  <ul class="shop-pagination">
    <li>
      <nuxt-link
        v-if="lastPage > 1"
        :key="previousPage"
        class="shop-pagination__button"
        :to="toPage(previousPage)"
        @click.prevent="changePage(previousPage)">
        <icon-angle-right class="shop-pagination__icon shop-pagination__icon--previous" />
      </nuxt-link>
    </li>
    <li class="shop-pagination__item" v-for="(page, index) in pages" :key="`${page}-${index}`">
      <nuxt-link
        v-if="page > 0"
        :key="page"
        class="shop-pagination__button"
        :class="itemClass(page)"
        :to="toPage(page)"
        @click.prevent="changePage(page)">
        {{ page }}
      </nuxt-link>
      <span class="shop-pagination__placeholder" v-else>
        ...
      </span>
    </li>
    <li>
      <nuxt-link
        v-if="lastPage > 1"
        :key="nextPage"
        class="shop-pagination__button"
        :to="toPage(nextPage)"
        @click="changePage(nextPage)">
        <icon-angle-right class="shop-pagination__icon" />
      </nuxt-link>
    </li>
  </ul>
</template>

<script lang="ts">
import IconAngleRight from '~/assets/icons/IconAngleRight.svg';
import { useSearchStore } from "~/stores/searchStore";

export default {
  setup () {
    return {
      searchStore: useSearchStore(),
    };
  },
  components: {
    IconAngleRight,
  },
  emits: ['to-page'],
  computed: {
    currentPage () {
      return this.searchStore.meta.currentPage;
    },
    totalResults () {
      return this.searchStore.meta.totalResults;
    },
    previousPage () {
      return Math.max(this.currentPage - 1, 1);
    },
    nextPage () {
      return Math.min(this.currentPage + 1, this.lastPage);
    },
    lastPage (): number {
      return Math.ceil(this.totalResults / 30);
    },
    pages () {
      const countPages = this.lastPage;
      const returnArray = [];
      const current = this.currentPage;

      let earliestPage;
      let latestPage;

      if (countPages > 1) {
        returnArray.push(1);
      }

      if (current < 7 || countPages <= 10) {
        earliestPage = 2;
      } else {
        returnArray.push(-1);
        earliestPage = current - 3;
      }
      if (current < 7 && countPages > 10) {
        latestPage = 7;
      } else if (countPages - current < 7 || countPages <= 10) {
        latestPage = countPages - 1;
      } else {
        latestPage = current + 3;
      }
      for (let i = earliestPage; i <= latestPage; i += 1) {
        returnArray.push(i);
      }
      if (latestPage !== (countPages - 1)) {
        returnArray.push(-2);
      }

      if (this.lastPage > 1) {
        returnArray.push(this.lastPage);
      }

      return returnArray;
    },
  },
  methods: {
    toPage (targetPage) {
      const { name, params, query } = this.$route;

      return {
        name,
        params,
        query: {
          ...query,
          page: targetPage,
        },
      };
    },
    changePage (targetPage) {
      this.searchStore.meta.currentPage = targetPage;
      this.$emit('to-page');
    },
    itemClass (page) {
      return {
        'shop-pagination__button--active': page === this.currentPage,
      };
    },
  },
};
</script>

<style lang="scss">
@use "~/common/scss/variables";
@use "~/common/scss/helpers";

.shop-pagination {
  display: flex;
  flex-flow: row wrap;
  gap: 2px;
  justify-content: center;
  list-style: none;
  margin: 0 auto 2rem;
  max-width: 100%;
  padding: 2rem 0 0;
  width: max-content;

  &__placeholder,
  &__button {
    align-items: center;
    color: variables.$colorGrey;
    display: flex;
    justify-content: center;
    min-width: helpers.px-to-rem(32);
    height: helpers.px-to-rem(32);
    padding: .25rem .5rem;
  }

  &__button {
    border: 1px solid variables.$colorGrey;
    border-radius: 4px;
    text-decoration: none;
    transition: background-color .25s;

    &:hover,
    &--active {
      background-color: variables.$colorWhite;
    }

    &--active {
      //color: variables.$colorBlack;
      background-color: variables.$colorGreyLight;
    }
  }

  &__icon {

    &--previous {
      transform: rotate(180deg);
    }
  }
}
</style>
